import ExclusiveBenefits from "./ExclusiveBenefits.jsx";
import Depoimentos from './Depoimentos.jsx';
import PreValue from './PreValue.jsx';
import PriceHero from './PriceHero.jsx';
import CTAPosValue from './CTA-PosValue.jsx';
import './styles/bg.css';

function MediumBg() {
    return (
        <div className="MediumBg">
            <ExclusiveBenefits/>
            <Depoimentos/>
            <PreValue/>
            <PriceHero/>
            <CTAPosValue/>
        </div>
    )
};

export default MediumBg;